module.exports = {"130635100":"蠡吾镇","130635101":"留史镇","130635102":"大百尺镇","130635103":"辛兴镇","130635104":"北郭丹镇","130635105":"万安镇","130635106":"桑园镇","130635107":"南庄镇","130635108":"大曲堤镇","130635109":"鲍墟镇","130635110":"小陈镇","130635201":"林堡乡","130635202":"北埝头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130635.json
// module id = 255
// module chunks = 0